import React, { useEffect, useRef } from 'react';
import DebounceInput from 'react-debounce-input';

/* Icons */
import CloseIcon from '~/../symbols/cross.svg';

/* Components */
import SearchResults from './SearchResults';

/* Common */
import { Button } from '~/components/common';

/* Utilities */
import { trans } from '~/utilities';

export default function SearchOverlay({ results, query, updateQuery, closeSearch, resultsUrl }) {
    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef?.current) {
            inputRef.current?.focus();
        }
    }, [inputRef]);

    return (
        <>
            <div className="search__overlay-header">
                <p className="text--18 font-weight-medium mb-0">{trans('app.header.search.title')}</p>
                <Button
                    theme="none"
                    title={trans('app.header.search.close')}
                    showTitle={false}
                    className="p-0"
                    showIcon={true}
                    icon={CloseIcon}
                    iconSize={14}
                    onClick={closeSearch}
                />
            </div>
            <div className="search__overlay-input-wrapper">
                <DebounceInput
                    inputRef={inputRef}
                    debounceTimeout={500}
                    type="text"
                    className="form-control form-control--search search__overlay-input"
                    value={query}
                    placeholder={trans('app.header.search.placeholder')}
                    onChange={(event) => updateQuery(event.target.value)}
                />
            </div>
            <div className="search__overlay-body">
                <SearchResults
                    results={results}
                    resultsUrl={resultsUrl}
                />
            </div>
        </>
    );
}
